module.exports = __webpack_public_path__ + "static/media/21_plantilla_cuadrada_combo_duo_cp_stills_pet_500_aq_pom.e586bfd4.png";